export default "__VITE_ASSET__rN_1li4k2aIbHGs0zKW8QQ__$_?url=true&w=1200&format=jpg&quality=80__"